/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

import { Partner } from '../constants';
import { PartnerList } from '../models';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'partner-list-picker',
  templateUrl: './partner-list-picker.component.html'
})
export class PartnerListPickerComponent implements OnInit {

  @Input()
  partner: Partner;

  @Input()
  selectedList: PartnerList;

  @Output('onChange')
  onChange: EventEmitter<PartnerList> = new EventEmitter<PartnerList>();

  loadingLists: boolean = true;
  lists: any[] = [];
  currentList: string;
  errorState: boolean = false;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {
    if (this.partner) {
      this.loadLists();
    }
  }

  /**
   * Listen for changes to the partner value in order to properly refresh lists when switching from
   * one integration to another
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.partner && changes.partner.previousValue &&  changes.partner.previousValue.name) {
      // clear list value, reload lists for partner, and emit a change event
      this.selectedList = null;
      this.currentList = null;
      this.refreshLists();
      this.onChange.emit(null);
    }
  }

  changeList(list) {
    this.selectedList = {
      id: list.value,
      name: list.label
    };
    this.onChange.emit(this.selectedList);
  }

  refreshLists() {
    this.partnerService.clearListCache(this.partner.name);
    this.loadLists();
  }

  clearList() {
    this.selectedList = null;
    this.currentList = null;
    this.onChange.emit(this.selectedList);
  }

  private loadLists() {
    console.log(this.partner);
    this.loadingLists = true;
    this.errorState = false;
    this.lists = [];
    this.partnerService.getLists(this.partner.name).subscribe(
      (result: any) => {
        result.forEach(l => {
          this.lists.push({
            label: l.name,
            value: l.id.toString()
          });

          if (this.selectedList && this.selectedList.id == l.id) {
            this.currentList = l.id.toString();
          }
        });

        this.lists.sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }
          else {
            return 1;
          }
        });
        this.loadingLists = false;
      },
      error => {
        this.errorState = true;
        this.loadingLists = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/global/partner-list-picker/partner-list-picker.component.ts